import SigliveServiceV1 from 'Service/sigliveServiceV1';

const getExportReportHelpPartner = async (queries = '') => {
  const { data } = await SigliveServiceV1({ method: 'GET', url: `help-host-report/export?${queries}`, responseType: 'blob' });

  return data;
};

export default getExportReportHelpPartner;
